import {
  CONNECT_KLAVIYO_REQUEST,
  CONNECT_KLAVIYO_SUCCESS,
  CONNECT_KLAVIYO_FAILURE,
  DISCONNECT_KLAVIYO_REQUEST,
  DISCONNECT_KLAVIYO_SUCCESS,
  DISCONNECT_KLAVIYO_FAILURE
} from '../actions/klaviyoActions';

const initialState = {
  klaviyoData: null,
  saving: false,
  error: null,
  validationErrors: null,
  lastMessage: null
};

const klaviyoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONNECT_KLAVIYO_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        validationErrors: null,
        lastMessage: null
      };

    case CONNECT_KLAVIYO_SUCCESS:
      return {
        ...state,
        saving: false,
        klaviyoData: action.payload.data || state.klaviyoData,
        error: null,
        validationErrors: null,
        lastMessage: action.payload.message || 'Klaviyo connected successfully'
      };

    case CONNECT_KLAVIYO_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.payload,
        validationErrors: action.payload.validationErrors || null,
        lastMessage: null
      };

    case DISCONNECT_KLAVIYO_REQUEST:
      return {
        ...state,
        saving: true,
        error: null,
        lastMessage: null
      };

    case DISCONNECT_KLAVIYO_SUCCESS:
      return {
        ...state,
        saving: false,
        lastMessage: action.payload?.message || 'Disconnected successfully'
      };

    case DISCONNECT_KLAVIYO_FAILURE:
      return {
        ...state,
        saving: false,
        error: action.error || 'Failed to disconnect',
        lastMessage: null
      };

    default:
      return state;
  }
};

export default klaviyoReducer;

